import React from "react";
import { useHistory } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import bg from '../assets/bg.svg';
import error from '../assets/error.svg';
import wave from '../assets/wave.png';
import {NotFoundPage, Wave, Container, ImgContent, NotFoundContent, Button } from "../styles";

function NotFound() {
    const history = useHistory();
    function goHome() {
        history.push("/home");
    }
    return(
        <NotFoundPage>
          <Wave src={wave} alt="Wave" />
          <Container>
              <ImgContent>
                <img src={bg} alt="Background" />
              </ImgContent>
              <NotFoundContent>
                <img src={error} alt="Error" />
                <h3>Page Not Found</h3>
                <Button onClick={()=> goHome()}>Home <FaArrowRight /></Button>
              </NotFoundContent>
          </Container>
        </NotFoundPage>
    );
}

export default NotFound;